import { ICommandBase } from '@/commands/interface/iCommandBase';
import { Document } from '@/model/document2/document';

// 新規ページコマンド
export class NewPageCommand implements ICommandBase
{
    private index! : number;
    private document! : Document;
    private doneCallback! : () => void;

    constructor(index : number, document : Document, doneCallback : () => void)
    {
        this.index = index;
        this.document = document;
        this.doneCallback = doneCallback;
    }

    public do() : void
    {
        // 空のページを作成する。
        var newPage = this.document.createNewPage();
        // 空ページを追加
        this.document.insertPage(this.index, newPage);
        
        this.doneCallback();
    }

    public undo() : void
    {
        // 最終ページがカレントの場合は、カレントが消滅するので一つ前に移動
        if(this.document.currentPageIndex >= this.document.pageList.length - 1)
        {
            this.document.currentPageIndex = this.document.pageList.length - 2;
        }
        // ページを削除
        this.document.removePage(this.index);

        this.doneCallback();
    }

    public redo() : void
    {
        // 空のページを作成する。
        var newPage = this.document.createNewPage();
        // 空ページを追加
        this.document.insertPage(this.index, newPage);
        
        this.doneCallback();
    }
}
